export const TESTIMONIALS = [
  {
    name: "Charlie Shen",
    role: "Lead DevOps Engineer, Brainfish",
    testimonial: "I've studied more than 10 observability tools in the market. We eventually landed on SigNoz, which says a lot. Compared to Elastic Cloud, it's a breeze with SigNoz.",
    image: "/img/case_study/profile-photos/brainfish.webp"
  },
  {
    name: "Niranjan Ravichandra",
    role: "Co-founder & CTO, Cedana",
    testimonial: "Getting started with SigNoz was incredibly easy. We were able to set up the OpenTelemetry collector quickly and start monitoring our systems almost immediately.",
    image: "/img/case_study/profile-photos/cedana.webp"
  },
  {
    name: "Poonkuyilan V",
    role: "IT Infrastructure Lead, The Hindu",
    testimonial: "Recently, we configured alerts for pod restarts and were able to quickly identify and resolve the root cause before it escalated. Additionally, SigNoz's tracing capabilities helped us spot unwanted calls to third-party systems, allowing us to optimize our applications.",
    image: "/img/case_study/profile-photos/the-hindu.png"
  },
  {
    name: "Avneesh Kumar",
    role: "VP of Engineering, Mailmodo",
    testimonial: "We have started saving almost six hours on a daily basis, which we can now invest in other tech debts and backlogs. The best thing about SigNoz is that it's open source. I can go into the source code and look at what's happening. That's a great confidence booster for long-term usage.",
    image: "/img/case_study/profile-photos/mailmodo.webp"
  },
  {
    name: "Khushhal Reddy",
    role: "Senior Backend Engineer, Kiwi",
    testimonial: "SigNoz is something we use daily. If I have ten tabs open, six of them are SigNoz. We used traces and it helped us take 30 seconds down to 3 seconds.",
    image: "/img/case_study/profile-photos/kiwi.webp"
  }
];
